export default __webpack_public_path__ + "static/media/texts_blue_icon.f2c8891d.svg";